import { render } from "./ResetPwdForm.vue?vue&type=template&id=80edbda2&scoped=true"
import script from "./ResetPwdForm.vue?vue&type=script&lang=js"
export * from "./ResetPwdForm.vue?vue&type=script&lang=js"

import "./ResetPwdForm.vue?vue&type=style&index=0&id=80edbda2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80edbda2"]])

export default __exports__